import { render, staticRenderFns } from "./bidSecondQuotate.vue?vue&type=template&id=1ddbe9f8&scoped=true"
import script from "./bidSecondQuotate.vue?vue&type=script&lang=js"
export * from "./bidSecondQuotate.vue?vue&type=script&lang=js"
import style0 from "./bidSecondQuotate.vue?vue&type=style&index=0&id=1ddbe9f8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ddbe9f8",
  null
  
)

export default component.exports